import React from "react";
import { Helmet } from "react-helmet-async";

export default function Geciciİs() {
  return (
    <div>
      <Helmet>
        <title>
          Geçici İş Görmezlik Tazminatı: Trafik Kazası Sonrası Bilmeniz
          Gerekenler
        </title>
        <meta
          name="description"
          content="Trafik kazası sonrası çalışamıyor musunuz? Geçici iş göremezlik tazminatı nedir, kimler talep edebilir ve hukukumuzda size sunulan haklar nelerdir? Detayları bu yazıda bulabilirsiniz."
        />
        <link rel="canonical" href="/" />
      </Helmet>
      <div className="sm:w-full  sm:mx-auto mt-10 ">
        <h1 className="text-center font-extrabold text-red-900 text-3xl">
          Geçici İş Görmezlik Tazminatı
        </h1>
      </div>
      <div className="sm:mx-96 mx-2 text-gray-700 font-light text-lg">
        <p className="mt-8">
          Trafik kazası sonrası geçici iş göremezlik tazminatı, bir trafik
          kazası sonucunda zarar gören kişinin, kazanın yol açtığı yaralanma
          veya sakatlık nedeniyle geçici olarak çalışamaması durumunda, bu süre
          zarfında yaşanan gelir kaybının tazmin edilmesini amaçlayan bir
          tazminat türüdür. Hukukumuzda bu tazminat, trafik kazası sonucunda
          geçici bir iş göremezlik yaşayan kişilere tanınan haklardan biridir ve
          kusurlu aracın zorunlu trafik sigortası tarafından tazmin edilir.
        </p>
        <p className="mt-8">
          Geçici iş göremezlik tazminatı, kazanın etkisiyle zarar görenin tedavi
          ve iyileşme sürecinde geçici olarak çalışmaması sonucunda yaşadığı
          gelir kaybını karşılamayı amaçlar. Bu süre zarfında zarar görenin,
          normalde çalıştığı işten kaynaklanan geliri veya kazanç kaybı tazmin
          edilir.
        </p>

        <p className="mt-8">
          Tazminat miktarı, zarar görenin normalde elde ettiği gelirin, trafik
          kazası sonucu geçici olarak çalışamadığı süre boyunca kaybettiği
          gelirin bir kısmını temsil eder. Genellikle bu miktar kazanç kaybının
          süresine, gelir düzeyine ve diğer faktörlere bağlı olarak belirlenir.
        </p>

        <p className="mt-8">
          Geçici iş göremezlik tazminatı, zarar görenin tedavi sürecinde olduğu
          veya sakatlık nedeniyle geçici olarak çalışamadığı süre boyunca
          yaşadığı gelir kaybını karşılar. Tazminat talebi için zarar görenin,
          geçici iş göremezlik sürecini tıbbi raporlar, doktor raporları, tedavi
          süreçleri ve diğer delillerle kanıtlaması gerekmektedir.
        </p>
        <p className="mt-8">
          Geçici iş göremezlik tazminatı, zarar görenin ekonomik kayıplarının
          azaltılması, geçici çalışma kapasitesinin telafi edilmesi ve yaşam
          standartlarının korunması amacıyla önemli bir yasal araçtır. Bu
          tazminat, trafik kazası sonucunda tedavi ve iyileşme sürecinde olan
          kişilerin maddi açıdan desteklenmesini sağlar. Tazminat miktarı,
          mahkeme tarafından zarar görenin durumuna ve kaybettiği gelire göre
          belirlenir.
        </p>
        <p className="mt-8">
          Sonuç olarak, trafik kazası sonrası geçici iş göremezlik tazminatı,
          trafik kazası nedeniyle geçici olarak çalışamayan kişinin yaşadığı
          gelir kaybının tazmin edilmesini amaçlar. Bu tazminat, zarar görenin
          tedavi süreci veya iyileşme sürecindeki gelir kaybını karşılamayı
          hedefler. Tazminat miktarı, zarar görenin normalde elde ettiği
          gelirin, geçici olarak çalışamadığı süre boyunca kaybettiği gelirin
          bir kısmını temsil eder.
        </p>
      </div>
    </div>
  );
}
